/**
 * 区分 taskStatus（monthly_checklist_tasks.task_status）
 * 出典：要件書 5.2
 */
export const TASK_STATUS_VALUES = ['incomplete', 'completed'] as const;

export type TaskStatus = (typeof TASK_STATUS_VALUES)[number];

export const TASK_STATUS_LABELS: Readonly<Record<TaskStatus, string>> = {
  incomplete: '未完了',
  completed: '完了',
};
